// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

export const getAccounts = async (input = '', dealerId) => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
            }
        }`
        let conditions = [{
            fields: ["name"],
            terms: [input],
            exact: false
        }]

        if (dealerId) {
            conditions.push({
                fields: ["dealerId"],
                terms: [dealerId],
                exact: true
            })
        }

        return await clientQuery(QUERY, {
            conditions,
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'getAccounts');
    }
}